import {
  Button,
  Col,
  Row,
  Space,
  Typography,
  Select,
  Divider,
  Input,
  Form,
} from "antd";
import React, {useEffect} from "react";
import Icons from "assets/icons";
import "./GonioscopyExpand.scss";
import {DataInputField} from "components/common";
import Icon from "@ant-design/icons";
import {useAppSelector} from "redux/hooks";

type Props = {
  isOpen: boolean;
  setIsOpen: () => void;
  index: number;
};
const listSelect1 = [
  {value: "0", label: "0"},
  {value: "1", label: "1"},
  {value: "2", label: "2"},
  {value: "3", label: "3"},
  {value: "4", label: "4"},
];
const listSelect2 = [
  {value: "SS", label: "SS"},
  {value: "TM-Ant", label: "TM-Ant"},
  {value: "TM-Post", label: "TM-Post"},
  {value: "CB", label: "CB"},
  {value: "SL", label: "SL"},
];
const listSelect3 = [
  {value: "NVI", label: "NVI"},
  {value: "PAS", label: "PAS"},
];
const GonioscopyExpand = ({isOpen, setIsOpen, index}) => {
  const objectChanDoan = useAppSelector(
    state => state.examination.objectChanDoan
  );
  const ref = useAppSelector(state => state.examination.ref);
  useEffect(() => {
    if (!isOpen) {
      // const fieldsValue = ref.getChanDoanValue();
      if (ref) {
        ref.setFieldValue(
          [`${index == 1 ? "leftJsonValue" : "rightJsonValue"}`, "GONIOSCOPY"],
          null
        );
      }
    }
    if (ref) {
      ref.setFieldValue(
        [
          `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
          "GONIOSCOPY",
          "show",
        ],
        isOpen
      );
    }
  }, [isOpen, ref]);
  useEffect(() => {
    if (objectChanDoan && ref) {
      const show = ref.getFieldValue([
        `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
        "GONIOSCOPY",
        "show",
      ]);
      if (Boolean(show) == true && isOpen == false) {
        setIsOpen();
      }
      if (Boolean(show) == false && isOpen == true) {
        setIsOpen();
      }
    }
  }, [objectChanDoan, ref]);
  return (
    <Space
      direction="vertical"
      className="space-common space-gonioscopy"
      size={"middle"}
    >
      <Row justify={"start"} className="row-common">
        <Button
          type="primary"
          icon={isOpen ? <Icons.sub /> : <Icons.add />}
          onClick={setIsOpen}
        />
        <Typography className="title-common-healthy">
          SOI GÓC TIỀN PHÒNG
        </Typography>
      </Row>

      {isOpen ? (
        <div>
          <Row gutter={[16, 8]}>
            <Col span={24}>
              <Form.Item
                label="Trên"
                labelCol={{xs: 6, md: 6, lg: 6}}
                wrapperCol={{xs: 18, md: 18, lg: 18}}
                labelAlign="left"
                className="form-item-super"
              >
                <Row gutter={16}>
                  <Col flex={1}>
                    <Form.Item
                      name={[
                        index === 0 ? "rightJsonValue" : "leftJsonValue",
                        "GONIOSCOPY",
                        "Trên",
                        "select1",
                      ]}
                    >
                      <Select
                        allowClear
                        placeholder="Chọn"
                        options={listSelect1}
                      />
                    </Form.Item>
                  </Col>
                  <Col flex={1}>
                    <Form.Item
                      name={[
                        index === 0 ? "rightJsonValue" : "leftJsonValue",
                        "GONIOSCOPY",
                        "Trên",
                        "select2",
                      ]}
                    >
                      <Select
                        allowClear
                        placeholder="Chọn"
                        options={listSelect2}
                      />
                    </Form.Item>
                  </Col>
                  <Col flex={1}>
                    <Form.Item
                      name={[
                        index === 0 ? "rightJsonValue" : "leftJsonValue",
                        "GONIOSCOPY",
                        "Trên",
                        "select3",
                      ]}
                    >
                      <Select
                        allowClear
                        placeholder="Chọn"
                        options={listSelect3}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
            <Divider />
            <Col span={24}>
              <Row>
                <Col span={8}>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <Typography.Text>Thái dương</Typography.Text>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name={[
                          index === 0 ? "rightJsonValue" : "leftJsonValue",
                          "GONIOSCOPY",
                          "Thái dương",
                          "select1",
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="Chọn"
                          options={listSelect1}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name={[
                          index === 0 ? "rightJsonValue" : "leftJsonValue",
                          "GONIOSCOPY",
                          "Thái dương",
                          "select2",
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="Chọn"
                          options={listSelect2}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name={[
                          index === 0 ? "rightJsonValue" : "leftJsonValue",
                          "GONIOSCOPY",
                          "Thái dương",
                          "select3",
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="Chọn"
                          options={listSelect3}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col span={8} className="close-col-container">
                  <Icons.close style={{fontSize: "40px"}} />
                </Col>
                <Col span={8}>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <Typography.Text>Mũi</Typography.Text>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name={[
                          index === 0 ? "rightJsonValue" : "leftJsonValue",
                          "GONIOSCOPY",
                          "Mũi",
                          "select1",
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="Chọn"
                          options={listSelect1}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name={[
                          index === 0 ? "rightJsonValue" : "leftJsonValue",
                          "GONIOSCOPY",
                          "Mũi",
                          "select2",
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="Chọn"
                          options={listSelect2}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name={[
                          index === 0 ? "rightJsonValue" : "leftJsonValue",
                          "GONIOSCOPY",
                          "Mũi",
                          "select3",
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="Chọn"
                          options={listSelect3}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Divider />
            <Col span={24}>
              <DataInputField
                label="Dưới:"
                itemScale={{first: 6, second: 18}}
                children={
                  <Row gutter={16}>
                    <Col flex={1}>
                      <Form.Item
                        name={[
                          index === 0 ? "rightJsonValue" : "leftJsonValue",
                          "GONIOSCOPY",
                          "Dưới",
                          "select1",
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="Chọn"
                          options={listSelect1}
                        />
                      </Form.Item>
                    </Col>
                    <Col flex={1}>
                      <Form.Item
                        name={[
                          index === 0 ? "rightJsonValue" : "leftJsonValue",
                          "GONIOSCOPY",
                          "Dưới",
                          "select2",
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="Chọn"
                          options={listSelect2}
                        />
                      </Form.Item>
                    </Col>
                    <Col flex={1}>
                      <Form.Item
                        name={[
                          index === 0 ? "rightJsonValue" : "leftJsonValue",
                          "GONIOSCOPY",
                          "Dưới",
                          "select3",
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="Chọn"
                          options={listSelect3}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                }
              />
            </Col>

            <Col span={24}>
              <Form.Item
                label={"Ghi chú"}
                labelCol={{xs: 6, md: 6, lg: 6}}
                wrapperCol={{xs: 18, md: 18, lg: 18}}
                labelAlign="left"
                name={[
                  index === 0 ? "rightJsonValue" : "leftJsonValue",
                  "GONIOSCOPY",
                  "Dưới",
                  "Comments",
                ]}
              >
                <Input className="data-input-gonioscopy" />
              </Form.Item>
            </Col>
            <Form.Item
              style={{display: "none"}}
              name={[
                `${index == 0 ? "rightJsonValue" : "leftJsonValue"}`,
                "GONIOSCOPY",
                "show",
              ]}
            >
              <Input />
            </Form.Item>
          </Row>
        </div>
      ) : null}
    </Space>
  );
};

export default GonioscopyExpand;
